import * as React from 'react';
import {
    Controller,
    Menu,
    Toolbar,
    UIConfig,
    WorkbenchUIConfig,
    Loader,
    IDynamicLoader,
    IActionPointInfo,
    ActionPointInfo,
} from '@tencent/workbench';
import { InsertShapeFeature } from '@framework/workbench/ui/insert/insert-shape/insert-shape-feature';
import {
    TOOLBAR_ITEMS,
    INSERT_SHAPE_MENU_CONFIGS,
    config, CUSTOM_SHAPE,
    TAILOR_PIC_SHAPE,
} from './config';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: INSERT_SHAPE_MENU_CONFIGS,
})
export class InsertShapeController {
    constructor(private readonly feature: InsertShapeFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    public getPcBtnDropdownContent(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.getContent(info);
    }

    @Menu(`${CUSTOM_SHAPE.name}`, 'content')
    @Menu(`${TAILOR_PIC_SHAPE.name}`, 'content')
    public getPcBtnContent(@UIConfig() config: WorkbenchUIConfig, @ActionPointInfo() info: IActionPointInfo) {
        return this.feature.getPcBtnContent(config, info);
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    @Toolbar(wrapIdForBig(config.id), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }
}
